export default __webpack_public_path__ + "static/media/springboot.ba04be8e.png";